import { useState, useEffect } from 'react';
import PubSub from 'pubsub-js'

import auth from '../services/auth';
import log from '../services/log'

function useUser() {
  const [user, setUser] = useState(auth.getUser());

  useEffect(() => {
    var token = PubSub.subscribe('LOGIN', (msg, data) => {
      setUser(auth.getUser())
    });

    return () => {
      PubSub.unsubscribe(token);
    }
  }, []);

  useEffect(() => {
    var token = PubSub.subscribe('LOGOUT', (msg, data) => {
      setUser(auth.getUser())
    });

    return () => {
      PubSub.unsubscribe(token);
    }
  }, []);

  useEffect(() => {
    var token = PubSub.subscribe('REFRESH', (msg, data) => {
      setUser(auth.getUser())
    });

    return () => {
      PubSub.unsubscribe(token);
    }
  }, []);

  useEffect(() => {
    var token = PubSub.subscribe('UNSUB', (msg, data) => {
      setUser(auth.getUser())
    });

    return () => {
      PubSub.unsubscribe(token);
    }
  }, []);

  useEffect(() => {
    var token = PubSub.subscribe('PORTFOLIO_CHANGED', (msg, data) => {
      setUser(auth.getUser())
    });

    return () => {
      PubSub.unsubscribe(token);
    }
  }, []);

  return [user];
}

export default useUser;